import { render, staticRenderFns } from "./ComTotal.vue?vue&type=template&id=fa04631a&scoped=true&"
import script from "./ComTotal.vue?vue&type=script&lang=js&"
export * from "./ComTotal.vue?vue&type=script&lang=js&"
import style0 from "./ComTotal.vue?vue&type=style&index=0&id=fa04631a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa04631a",
  null
  
)

export default component.exports